import * as z from "zod/v4";

export const getOrderSourceNames = {
  name: "getOrderSourceNames" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(z.string()),
};
